import AppForm from '../app-components/Form/AppForm';

Vue.component('financial-balance-form', {
    mixins: [AppForm],
    props: {
        selectedOffice: {
            type: Object,
            default: () => {}
        },
    },
    data: function() {
        return {
            form: {
                app_offices_id:  '' ,
                account_id:  '' ,
                account_name:  '' ,
                account_type:  '' ,
                source_type:  '' ,
                balance:  0 ,
                
            },
            tempOffice: null
        }
    },
    methods:{
        onSelectOffice(appOffice, id) {
            if (appOffice !== null) {
                this.form.app_offices_id = appOffice.id;
            }else{
                this.form.app_offices_id = null;
            }
        },
        onChangeSourceType() {
            this.form.account_name = this.form.source_type
        },
    },
    mounted: function () {  
        this.tempOffice = this.selectedOffice
    },

});